import { ScorpionBlockLog } from "./scorpionBlock";
import { RunLog } from "../runLog";

export class ScorpionRunLog extends RunLog {
    block: ScorpionBlockLog | null;
    constructor(block: ScorpionBlockLog | null, init?: Partial<RunLog>) {
        super(init);
        this.block = block;
    }
}